import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

import {
    EntryTypeBlockCreateForm,
    EntryTypeBlockData,
    EntryTypeFieldData,
    FieldDataParams,
    Nullable,
} from 'chaika-frontend-types/frontend-cms';
import { EntryTypeFieldType } from 'chaika-enums';
import { FieldParams } from 'chaika-types';

import { BlockData, BlockFieldData } from '../types';

export function normalizeBlock(block: EntryTypeBlockData): BlockData {
    return {
        ...block,
        alwaysShow: block.alwaysShow ?? false,
        titleTranslations: block.titleTranslations ?? [],
        fields: (block.fields ?? []).map(normalizeField),
    };
}

export function normalizeField(field: EntryTypeFieldData): BlockFieldData {
    return {
        ...field,
        id: field.name,
        global: field.global ?? false,
        titleTop: field.titleTop ?? true,
        data: (field.data as Nullable<FieldDataParams>) ?? {},
        titleTranslations: field.titleTranslations ?? [],
        formula: getFixedFormula(field.type, field.formula),
    };
}

export function getFixedFormula(type: EntryTypeFieldType, formula?: Nullable<string>): Nullable<string> | undefined {
    if (!!formula && type !== EntryTypeFieldType.Computed && type !== EntryTypeFieldType.CustomComputed) {
        return undefined;
    }

    return formula;
}

export function toBlockSaveForm(block: BlockData): EntryTypeBlockCreateForm {
    return {
        title: block.title,
        name: block.name,
        titleTranslations: block.titleTranslations,
        alwaysShow: block.alwaysShow,
        fields: block.fields.map(toFieldForm),
    };
}

export function toFieldForm(field: BlockFieldData): FieldParams {
    return omitBy(
        {
            name: field.name,
            type: field.type,
            data: field.data,
            global: field.global,
            title: field.title,
            titleTop: field.titleTop,
            placeholder: field.placeholder,
            width: field.width,
            dictionary: field.dictionary,
            formula: getFixedFormula(field.type, field.formula),
            titleTranslations: field.titleTranslations,
        },
        isNil,
    ) as unknown as FieldParams;
}
